module.exports = __webpack_public_path__ + "static/media/refund.b1929553.svg";